// @ts-nocheck


import React from 'react';

import Button from 'antd/lib/button';
import styled from 'styled-components';

import { Form } from './../../../components';
import { Section, Footer } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';

import CancelButton from './../../../components/CancelButton';
import Input from 'antd/lib/input';


const SectionContent = styled.div.withConfig({ displayName: "InnerForm__SectionContent", componentId: "sc-kbhmzv-0" })(["padding:16px;"]);









export default ({ washingVehicleType, onSubmit, onCancel }) => {
  return (
    <Form initialValues={washingVehicleType} onSubmit={onSubmit}>
      {(FormField, formikProps) => {
        const { handleSubmit, dirty } = formikProps;
        return (
          <form onSubmit={handleSubmit}>
            <Section>
              <SectionContent>
                <Grid gutter="16px">
                  <GridItem>
                    <FormField
                      label="Наименование типа ТС"
                      name="type"
                      required
                      fast>

                      {(field) =>
                      <Input
                        {...field}
                        placeholder="Введите наименование типа ТС" />

                      }
                    </FormField>
                  </GridItem>
                </Grid>
              </SectionContent>
            </Section>
            <Footer>
              <Button type="primary" htmlType="submit" data-cy="save">
                Сохранить
              </Button>
              <CancelButton dirty={dirty} onClick={onCancel}>
                Отменить
              </CancelButton>
            </Footer>
          </form>);

      }}
    </Form>);

};
